export default "__VITE_ASSET__594fa0aa__"